<div class="p-grid p-fluid">
  <div class="p-field p-col-12 p-md-12" *ngIf="noDisponible">
    <h3 [ngStyle]="{ color: 'var(--pink-500)' }">Tinte no disponible</h3>
  </div>
  <div
    class="p-field p-col-12 p-md-6"
    [ngStyle]="{ backgroundColor: 'var(--blue-100)' }"
  >
    <h5>
      Formula: {{ formulaChild?.pk.id }} - {{ tipo?.nombre }} - GSU #
      {{ formulaChild?.gsu }}
    </h5>
  </div>
  <div
    class="p-field p-col-12 p-md-6"
    *ngIf="formulaChild?.detalle?.length"
    [ngStyle]="{ backgroundColor: 'var(--blue-100)' }"
  >
    <div (click)="showDialog()">
      <img
        alt="mapa"
        src="/assets/mapa.PNG"
        style="width: 2rem"
        pTooltip="Ver mapa de color"
        tooltipPosition="top"
      />
    </div>
  </div>

  <br />
</div>
<div class="p-fluid">
  <p-table
  dataKey = "codigotinte"
    *ngIf="formulaChild?.detalle?.length"
    [value]="formulaChild?.detalle"
    [rowHover]="true"
    styleClass="p-datatable-sm p-datatable-striped"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 20%">Tinte</th>
        <th>Nombre</th>
        <th style="width: 20%">Cantidad</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-deta>
      <tr
        [style.background-color]="!deta.tinte.activo ? 'var(--pink-200)' : null"
      >
        <td>{{ deta.tinte.pk.codigo }}</td>
        <td>{{ deta.tinte.nombre }}</td>
        <td>{{ deta.cantidad }} gr.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<br />
<div class="p-grid p-fluid" *ngIf="formulaChild?.detalle?.length">
  <div class="p-field p-col-6 p-md-2">
    <b>Total: </b>
  </div>
  <div class="p-field p-col-6 p-md-2">
    <p *ngIf="formulaChild">{{ sumaTinte | number: "1.2-2" }} gr.</p>
  </div>
  <div class="p-field p-col-6 p-md-2">
    <span class="p-float-label">
      <p-inputNumber
        #inputCantidad
        [(ngModel)]="cantidad"
        locale="es-SV"
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
      >
      </p-inputNumber>
      <label>Cantidad</label>
    </span>
  </div>

  <div class="p-field p-col-6 p-md-2">
    <span class="p-float-label">
      <p-dropdown
        inputId="dropdown"
        [autoDisplayFirst]="true"
        [options]="medidas"
        [(ngModel)]="medida"
        optionLabel="nombre"
      ></p-dropdown>
      <label for="dropdown">Medida</label>
    </span>
  </div>
  <p-button
    class="p-field p-col-12 p-md-2 justify-content-center"
    (click)="convertir()" 
    [disabled]="noDisponible || blocked"
    iconPos="right"
    label="Calcular"
    icon="pi pi-cog"
  ></p-button>
</div>

<hr />


<p-dialog
  header="Mapa de Tintes"
  [(visible)]="display"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [style]="{width: '1100px', height: '700px'}"
>
  <div class="p-grid mapa-layout">

  <!-- MAPA -->
  <div class="p-col-12 p-md-9 mapa-container" #mapContainer>

    <p-scrollPanel
      [style]="{ width: '100%', height: '100%' }"
      styleClass="custombar2"
    >

      <svg
        *ngIf="formulaChild?.detalle?.length"
        width="800"
        height="525"
      >

        <style>
          .small {
            font: 12px sans-serif;
            font-weight: bold;
          }

          .tinte-link {
            text-decoration: none;
            cursor: pointer;
            transition: all .12s ease;
            pointer-events: all;
          }

          .tinte-link:hover {
            text-decoration-line: underline;
            text-decoration-style: solid;
            text-decoration-thickness: 1.2px;
            text-underline-offset: 2px;
            stroke: #111;
            stroke-width: .35;
            opacity: .92;
          }
        </style>

        <image
          width="800"
          height="525"
          xlink:href="/assets/color.png"
          clip-path="url(#circleView)"
        />

        <rect
          x="0"
          y="0"
          width="800"
          height="525"
          stroke="gray"
          stroke-width="1px"
          fill="white"
          fill-opacity="0"
        />

        <!-- RUEDA -->
        <text
          *ngFor="let deta of detaRueda"
          [attr.x]="deta.tinte.posx"
          [attr.y]="deta.tinte.posy"
          [attr.fill]="deta.tinte.colorTexto || 'black'"
          dominant-baseline="middle"
          text-anchor="middle"
          class="small tinte-link"
          (mouseenter)="onTinteHoverEnter($event, deta)"
          (mouseleave)="onTinteHoverLeave()"
        >
          {{ deta.tinte.pk.codigo }}
        </text>

        <!-- EJE SUPERIOR -->
        <text
          *ngFor="let deta of detaEjeSuperior; index as i"
          [attr.x]="ejeX"
          [attr.y]="ejeSuperior + i * 12"
          [attr.fill]="deta.tinte.colorTexto || 'black'"
          dominant-baseline="middle"
          text-anchor="middle"
          class="small tinte-link"
          (mouseenter)="onTinteHoverEnter($event, deta)"
          (mouseleave)="onTinteHoverLeave()"
        >
          {{ deta.tinte.pk.codigo }}
        </text>

        <!-- EJE INFERIOR -->
        <text
          *ngFor="let deta of detaEjeInferior; index as i"
          [attr.x]="ejeX"
          [attr.y]="ejeInferior + i * 12"
          [attr.fill]="deta.tinte.colorTexto || 'black'"
          dominant-baseline="middle"
          text-anchor="middle"
          class="small tinte-link"
          (mouseenter)="onTinteHoverEnter($event, deta)"
          (mouseleave)="onTinteHoverLeave()"
        >
          {{ deta.tinte.pk.codigo }}
        </text>

        <!-- EFECTOS -->
        <text
          *ngFor="let deta of detaEfecto; index as i"
          [attr.x]="efectosX"
          [attr.y]="efectosY + i * 12"
          [attr.fill]="deta.tinte.colorTexto || 'black'"
          dominant-baseline="middle"
          text-anchor="middle"
          class="small tinte-link"
          (mouseenter)="onTinteHoverEnter($event, deta)"
          (mouseleave)="onTinteHoverLeave()"
        >
          {{ deta.tinte.pk.codigo }}
        </text>

      </svg>

    </p-scrollPanel>

  </div>


 
  <div class="p-col-12 p-md-3 pictograma-panel">

    <ng-container *ngIf="hoverCardVisible; else sinPictograma">

      <div class="pictograma-contenido">

        <div class="tinte-header">
          <div class="tinte-codigo">
            {{hoverCardTinteCodigo}}
          </div>
          <div class="tinte-nombre">
            {{hoverCardTinteNombre}}
          </div>
        </div>

        <img
          *ngIf="hoverCardImagenSrc; else noHoverImage"
          [src]="hoverCardImagenSrc"
          alt="Pictograma"
          class="pictograma-imagen"
        />

        <div *ngIf="hoverCardDescripcionHtml; else noAsociado"><div class="ql-editor" style="padding: 0;" [innerHTML]="hoverCardDescripcionHtml"></div></div>

        <ng-template #noHoverImage>
          <div class="pictograma-placeholder">
            Sin imagen
          </div>
        </ng-template>

      </div>

    </ng-container>

    <ng-template #sinPictograma>

      <div class="pictograma-vacio">
        Posiciónese sobre un tinte para ver Pictograma
      </div>

    </ng-template>

    <ng-template #noAsociado>
      No hay ningun pictograma asociado a este tinte.
    </ng-template>

  </div>

</div>
</p-dialog>

<!-- 
  <div style="width: 500px; height: 500px">
    <img src="/assets/mapa.PNG" width="100%" height="100%" />
  </div> -->